import { cn, useCurrentTimestamp } from "@tellescope/ui";
import { useDateFnsFormattersWithLocale } from "@tellescope/ui";

export interface CurrentTimeLineProps {
  getTop?: (currentTimestamp: Date) => number;
  getBottom?: (currentTimestamp: Date) => number;
  shouldDisplay?: (currentTimestamp: Date) => boolean;
  className?: string;
  timezone?: string;
  textAvailableWidth?: number;
}

export const CurrentTimeLine = ({
  getTop,
  getBottom,
  shouldDisplay,
  className,
  timezone = Intl.DateTimeFormat().resolvedOptions().timeZone,
  textAvailableWidth,
}: CurrentTimeLineProps) => {
  const { formatInTimeZone } = useDateFnsFormattersWithLocale();
  const currentTimestamp = useCurrentTimestamp({ pollingRateInMs: 1000 * 60, snapTo: "minute" });

  if (shouldDisplay && !shouldDisplay(currentTimestamp)) {
    return null;
  }

  return (
    <div
      className={cn(
        "absolute text-xs flex items-center w-full h-[1px] overflow-visible pointer-events-none",
        className
      )}
      style={{ top: getTop?.(currentTimestamp), bottom: getBottom?.(currentTimestamp) }}
    >
      <span
        className="py-0.5 pr-1 rounded-full overflow-hidden bg-white text-nowrap flex-shrink-0 text-right"
        style={{ width: textAvailableWidth || 50 }}
      >
        {formatInTimeZone(currentTimestamp, timezone, "h:mm a")}
      </span>
      <div className="rounded-full bg-primary size-3 flex-shrink-0" />
      <span className="bg-primary h-[1px] w-full flex-grow" />
    </div>
  );
};
